// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentLinkCheckout_main__dRHGc {
  background-color: var(--color-dark-2);
  max-width: 100vw;
  min-height: 100vh;
  padding: 5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PaymentLinkCheckout_main__img__cKGiE {
  height: 7rem;
}
.PaymentLinkCheckout_main__titles__t7HF3 {
  width: 60rem;
}
@media only screen and (max-width: 31.25em) {
  .PaymentLinkCheckout_main__titles__t7HF3 {
    width: 42rem;
  }
}
.PaymentLinkCheckout_main__form__WkbP\\+ {
  background-color: var(--color-white);
  padding: 4rem 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 50rem;
}
@media only screen and (max-width: 31.25em) {
  .PaymentLinkCheckout_main__form__WkbP\\+ {
    width: 38rem;
  }
}

.PaymentLinkCheckout_beside__\\+uGjy {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 25em) {
  .PaymentLinkCheckout_beside__\\+uGjy {
    grid-template-columns: 100%;
  }
}

.PaymentLinkCheckout_beside2__jRbmw {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  margin-bottom: 2.5rem;
}
@media only screen and (max-width: 25em) {
  .PaymentLinkCheckout_beside2__jRbmw {
    display: grid;
    grid-template-columns: 100%;
  }
}

.PaymentLinkCheckout_mima__RnmZL {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
.PaymentLinkCheckout_mima__RnmZL > :not(:last-child) {
  margin-right: 1rem;
}
.PaymentLinkCheckout_mima__logo__vz1jt {
  height: 3rem;
}

.PaymentLinkCheckout_linksContainer__\\+J7Ex {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

.PaymentLinkCheckout_link__mcJaH {
  color: blue;
  cursor: pointer;
  font-size: 1.5rem;
  padding: 1rem;
}
.PaymentLinkCheckout_link__mcJaH:hover {
  font-weight: 510;
}

.PaymentLinkCheckout_besideContainer__nbcE5 {
  width: 100%;
}

.PaymentLinkCheckout_flex__eIS1W {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/PaymentLink/PaymentLinkCheckout.module.scss"],"names":[],"mappings":"AAEA;EACC,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADD;AAGC;EACC,YAAA;AADF;AAIC;EACC,YAAA;AAFF;AAGE;EAFD;IAGE,YAAA;EAAD;AACF;AAGC;EACC,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,YAAA;AADF;AAGE;EARD;IASE,YAAA;EAAD;AACF;;AAIA;EACC,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AADD;AAGC;EAND;IAOE,2BAAA;EAAA;AACF;;AAEA;EACC,aAAA;EACA,SAAA;EACA,8BAAA;EACA,qBAAA;AACD;AACC;EAND;IAOE,aAAA;IACA,2BAAA;EAEA;AACF;;AACA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAED;AAAC;EACC,kBAAA;AAEF;AACC;EACC,YAAA;AACF;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAAD;;AAGA;EACC,WAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAAD;AACC;EACC,gBAAA;AACF;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAAD","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tbackground-color: var(--color-dark-2);\n\tmax-width: 100vw;\n\tmin-height: 100vh;\n\tpadding: 5rem;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\t&__img {\n\t\theight: 7rem;\n\t}\n\n\t&__titles {\n\t\twidth: 60rem;\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 42rem;\n\t\t}\n\t}\n\n\t&__form {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 4rem 2rem;\n\t\tmargin: 1rem 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\twidth: 50rem;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 38rem;\n\t\t}\n\t}\n}\n\n.beside {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: repeat(2, 1fr);\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n.beside2 {\n\tdisplay: flex;\n\tgap: 2rem;\n\tjustify-content: space-between;\n\tmargin-bottom: 2.5rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n.mima {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 3rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__logo {\n\t\theight: 3rem;\n\t}\n}\n\n.linksContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 1rem;\n\tmargin-top: 2rem;\n}\n\n.link {\n\tcolor: blue;\n\tcursor: pointer;\n\tfont-size: 1.5rem;\n\tpadding: 1rem;\n\t&:hover {\n\t\tfont-weight: 510;\n\t}\n}\n\n.besideContainer {\n\twidth: 100%;\n}\n\n.flex {\n\tdisplay: flex;\n\tgap: 1rem;\n\tflex-wrap: wrap;\n\tmargin-bottom: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PaymentLinkCheckout_main__dRHGc`,
	"main__img": `PaymentLinkCheckout_main__img__cKGiE`,
	"main__titles": `PaymentLinkCheckout_main__titles__t7HF3`,
	"main__form": `PaymentLinkCheckout_main__form__WkbP+`,
	"beside": `PaymentLinkCheckout_beside__+uGjy`,
	"beside2": `PaymentLinkCheckout_beside2__jRbmw`,
	"mima": `PaymentLinkCheckout_mima__RnmZL`,
	"mima__logo": `PaymentLinkCheckout_mima__logo__vz1jt`,
	"linksContainer": `PaymentLinkCheckout_linksContainer__+J7Ex`,
	"link": `PaymentLinkCheckout_link__mcJaH`,
	"besideContainer": `PaymentLinkCheckout_besideContainer__nbcE5`,
	"flex": `PaymentLinkCheckout_flex__eIS1W`
};
export default ___CSS_LOADER_EXPORT___;
